/**
 * Journal Analytics slice
 */

import { createAction, createSlice } from '@reduxjs/toolkit';

export interface JournalAnalytics {
  totalJournalEntries: number;
  todayJournalEntries: number;
  weekJournalEntries: number;
  monthJournalEntries: number;
  topTags: Array<{ tag: string; count: number }>;
  moodDistribution: Array<{ mood: string; count: number }>;
}

const initialState = {
  journalAnalytics: null as JournalAnalytics | null,
  loading: false,
  error: null as string | null,
};

const journalAnalyticsSlice = createSlice({
  name: 'journalAnalytics',
  initialState,
  reducers: {
    setJournalAnalytics(state, action) {
      state.journalAnalytics = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    clearError(state) {
      state.error = null;
    },
  },
});

// Reducer
export const journalAnalyticsReducer = journalAnalyticsSlice.reducer;

// Actions
export const {
  setJournalAnalytics,
  setLoading,
  setError,
  clearError,
} = journalAnalyticsSlice.actions;

// Async Actions
export const fetchJournalAnalytics = createAction('JOURNAL_ANALYTICS/FETCH_ANALYTICS');

